// Prod is identified by the `prod.` subdomain prefix.
const isProdEnvironment = (): boolean => {
  return window.location.hostname.startsWith('prod.');
};

export const isPreProdEnvironment = (): boolean => {
  return !isProdEnvironment();
};

// Feature access is gated purely on environment: disabled in prod,
// enabled in every other environment. The permissions list is kept
// in the signature so call sites remain unchanged, but is not used
// at this time.
export const hasFeatureAccess = (_userPermissions: string[]): boolean => {
  return !isProdEnvironment();
};
